class YoutubeApiLoader {
  download() {
    let downloadResolve;
    this.loaded = false;

    window.onYouTubeIframeAPIReady = () => {
      this.loaded = true;
      downloadResolve();
    };

    return new Promise((resolve) => {
      downloadResolve = resolve;
      const tag = document.createElement('script');
      tag.onerror = () => resolve(true);
      tag.src = '//www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    });
  }

  get isLoaded() {
    return this.loaded;
  }
}

const instance = new YoutubeApiLoader();

export default instance;
